import React, { Component } from "react";
  import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import { setAppConfig } from "../../actions";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import {
  Collapse,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
} from "reactstrap";

import Logo from "../../core/components/Logo";
import { authHelpers } from "../../auth/helpers/auth";
import { store } from "../../store";
// import { Mixpanel } from "../../waitlist/components/MixPanel";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isActive: false,
      isDashboardActive: false,
      dropdownOpen : false,
    };

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  toggleNavbar() {
    sessionStorage.removeItem("instantAmount");
    this.setState({
      isOpen: !this.state.isOpen,
    });

    let config = {
      hideHeaders: false,
      renderHeaders: true,
    };
    store.dispatch(setAppConfig(config));
  }

  logout() {
    authHelpers.logout();
    window.location.reload();
  }

  recordMixPanel(tab) {
    this.setState({
      activeTab: tab
    })
    if (tab === "home") {
      if (this.props.userType === "fd") {
        window.open(process.env.REACT_APP_BASE_URL_FD, '_self')
      } else {
        window.open(process.env.REACT_APP_NEUTRAL_POST_URL + "/biddeasy-dashboard", '_self')
      }
    }
  }

  recordMixPanelBonds() {
    /* if (this.props.userEmail) Mixpanel.track("cl_orobonds_tab",
      {
        "Email id": this.props.userEmail
      }
    ); */
    this.setState({
      activeTab: "bonds"
    })
  }

  handleClick() {
    if (this.props.history.location.pathname === "/biddeasy-dashboard") {
      window.location.reload()
    } else {
      window.location.replace("/platform/#/biddeasy-dashboard")
    }
  };

  componentDidMount(){
    window.onhashchange = () => {
      this.onComponentMount();
    };
    if(this.props.history.location.pathname === '/'){
      this.setState({
        isDashboardActive: !this.state.isDashboardActive,
      });
    }
    if(this.props.history.location.pathname.split('/')[1] === "refer-dashboard"){
      this.setState({
        isActive: !this.state.isActive,
      });
    }
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
      productDropdown: false
    });
  }

  openDropdown = () => {
    this.setState({
      dropdownOpen: true,
    });
  };

  closeDropdown = () => {
    this.setState({
      dropdownOpen: false,
    });
  };


  openBondsLink = () => {
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent("Bonds_Tab_Click")
    }
    window.location.replace("/platform/#/biddeasy-dashboard");
  }

  openFdLink = () =>{
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent("FD_Tab_Click")
    }
    window.open(process.env.REACT_APP_BASE_URL_FD, '_self')
  }

  handleClick = () => {
    window.location.href = process.env.REACT_APP_NEUTRAL_URL + "platform/#/biddeasy-dashboard"
  };

  handleLearnClick = () => {
    window.open(`${process.env.REACT_APP_URL_ENDPOINTS}/blog`, '_blank')
  }

  componentDidMount() {
    this.previousUrl = window.location.href;
    if (window.location.href.split('/')[4] === "") {
      this.setState({
        activeTab: "bonds"
      })
    } else if (window.location.href.split('/')[4] === "biddeasy-dashboard") {
      this.setState({
        activeTab: "bonds"
      })
    }else if(window.location.href.split('/')[5] === "biddeasy-dashboard" || window.location.href.split('/')[5] === ""){
      this.setState({
        activeTab: "bonds"
      })
    } else {
      this.setState({
        activeTab: "bonds"
      })
    }
  }
 
  componentDidUpdate() {
    const currentUrl = window.location.href;
    const locationHash = window.location.hash;
    if (currentUrl !== this.previousUrl) {
      ReactGA.send({ hitType: 'pageview', page_location: `${locationHash}` });
      {
        process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent(locationHash, `${locationHash}`);
      }
    }
  }

  handleRefer = () => {
    window.open(process.env.REACT_APP_NEUTRAL_POST_URL + 'refer', '_self');
  }

  onComponentMount = () => {
    let hashUrl = (window.location.hash.split('/')[1]);
    if(hashUrl === "refer-dashboard"){
    this.setState({
      isActive: !this.state.isActive,
    });
    }else {
      this.setState({
        isActive: false,
      });
    }
    if(window.location.hash === "#/"){
      this.setState({
        isDashboardActive: !this.state.isDashboardActive,
      });
    }else{
      this.setState({
        isDashboardActive: false,
      });
    }
  }

  render() {
    window.onhashchange= () => {
      this.onComponentMount();
    }
    var cartTotal = 0;
    if (
      store.getState() &&
      store.getState().cart &&
      store.getState().cart.cartCounts
    ) {
      cartTotal = store.getState().cart.cartCounts.total;
    }

    var hideHeaders = this.props.hideHeaders;
    var renderHeader = this.props.renderHeaders;
    var isAmazon = this.props.isAmazon;
    return (
        <div className="container site-header" style={{ maxWidth: '100%' }}>
          <Navbar color="" light expand="lg" className="primary-navbar">
            <div onClick={this.toggleNavbar}>
              <NavbarBrand className="cursor-pointer avatar" onClick={this.props.handleLogoClick}
              >
                <Logo
                  className={classnames({ "py-3": hideHeaders })}
                />
              </NavbarBrand>
            </div>

            {renderHeader
              ? !hideHeaders && (
                <>
                  <div className="user-profile-menu d-md-none d-sm-block d-block">
                    {!this.props.isOrobonds &&
                      <Link to={{ pathname: "/carts" }}>
                        <div className="cart-container">
                          <div className="mdi mdi-cart cart-icon text-white"></div>
                          <div
                            className={classnames("cart-circle", {
                              "d-none": cartTotal <= 0,
                            })}
                          >
                            {cartTotal}
                          </div>
                        </div>
                      </Link>}
                    <div
                      className="cursor-pointer avatar"
                      onClick={this.props.onUserProfileClicked}
                    >
                      <i className="mdi mdi-menu"></i>
                    </div>
                  </div>
                  <Collapse
                    isOpen={this.state.isOpen}
                    navbar
                    className="d-lg-block d-xl-block d-none mr-auto"
                    style={{ maxWidth: "fit-content", height: '100%' }}
                  >
                    <Nav navbar>
                      <>
                        {/* <NavItem onClick={this.toggleNavbar}>
                          <NavLink
                            // activeClassName={this.state.activeTab === "home" ? "active" : ""}
                            to='/'
                            className="nav-link"
                            onClick={() => this.recordMixPanel("home")}
                          >
                            Home
                          </NavLink>
                        </NavItem> */}
                        <NavItem onClick={this.toggleNavbar}>                        
                          <p className="nav-link mb-0 cursor-pointer" onClick={this.props.handleLogoClick}>Home</p>
                        </NavItem>                      
                        <NavItem onClick={this.toggleNavbar}>
                          <NavLink
                            activeClassName={this.state.activeTab === "bonds" ? 'active' : ""}
                            to='/'
                            className="nav-link"
                            onClick={() => this.recordMixPanelBonds()}
                          >
                            Bonds 
                          </NavLink>
                        </NavItem>
                        <NavItem onClick={this.toggleNavbar} >                        
                          <p className="nav-link mb-0 cursor-pointer" onClick={() => this.props.handlePortfolioClick()}>Portfolio</p>
                        </NavItem>
                        <NavItem onClick={this.toggleNavbar} >                        
                          <p className="nav-link mb-0 cursor-pointer" onClick={() => this.props.handleReferClick()}>Refer</p>
                        </NavItem>

                        <NavItem onClick={this.props.handleFaqClick}>
                          <NavLink
                            activeClassName="active"
                            to='/faq'
                            className="nav-link"
                            onClick={() => this.recordMixPanel("faq")}
                          >
                            FAQs
                          </NavLink>
                        </NavItem>

                        <NavItem onClick={this.toggleNavbar}>                        
                          <p className="nav-link mb-0 cursor-pointer" onClick={this.handleLearnClick}>Learn</p>
                        </NavItem>

                          {/* <UncontrolledDropdown
                            isOpen={this.state.dropdownOpen} 
                            toggle={this.toggle} 
                            onMouseEnter={this.openDropdown}
                            onMouseLeave={this.closeDropdown} 
                            nav
                            inNavbar
                          >
                            <DropdownToggle nav caret>
                              <span>Learn</span>
                            </DropdownToggle>
                            <DropdownMenu bottom>
                              <DropdownItem
                                key={1}
                                onClick={() => (window.location.href = process.env.REACT_APP_BLOGS_POST_URL)}
                              >
                                Blogs
                              </DropdownItem>
                              <DropdownItem
                                key={1}
                                onClick={() => (window.open("https://incredmoney.wpcomstaging.com/newsletters/", "_blank"))}
                              >
                                Newsletters
                              </DropdownItem>
                              <DropdownItem
                                key={2}
                                onClick={() => (window.location.href = process.env.REACT_APP_BASE_URL_ICM + "/learn/calculators")}
                              >
                                Calculators
                              </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown> */}
                      </>
                    </Nav>
                  </Collapse>
                  <div className="user-profile-menu d-md-block d-sm-none d-xs-none d-none ml-auto">
                    {!this.props.isOrobonds && <Link to={{ pathname: "/carts" }}>
                      <div className="cart-container">
                        <div className="mdi mdi-cart cart-icon text-white"></div>
                        <div
                          className={classnames("cart-circle", {
                            "d-none": cartTotal <= 0,
                          })}
                        >
                          {cartTotal}
                        </div>
                      </div>
                    </Link>}
                    <div
                      className="cursor-pointer avatar"
                      onClick={this.props.onUserProfileClicked}
                    >
                      <i className="mdi mdi-menu"></i>
                    </div>
                  </div>
                </>
              )
              : ""}
          </Navbar>
        </div>
    );
  }
}

export default Header;
